import { connect } from 'react-redux';
import { toggleNavVisibility } from 'reducers/ui';
import { selectUserInfo } from 'selectors/general';
import { selectIsDesktop } from 'selectors/ui';
import HeaderFrame from './HeaderFrame';

const mapStateToProps = state => {
  const { isAuthenticated } = selectUserInfo(state);
  const isDesktop = selectIsDesktop(state);
  return {
    isAuthenticated,
    isDesktop,
    showVenueSelectorInsideHeader: isDesktop,
  };
};

const mapDispatchToProps = {
  toggleNavVisibility,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderFrame);
